import SplitInLines from 'utils/splitInLines';
import { forEach } from 'lodash';
import { debounce } from 'lodash';

export default class Link {
  constructor() {
    this.links = document.querySelectorAll('.u-link, [class*="u-link--"]');
    this.init();
  }

  init() {
    forEach(this.links, (link) => {
      this.split(link);
    })
    this.bind();
  }

  split(el) {
    el.innerHTML = el.textContent;
    new SplitInLines(el);
  }

  bind() {
    window.addEventListener('resize', debounce(this.resize.bind(this), 250));
  }

  resize() {
    forEach(this.links, (link) => {
      this.split(link);
    })
  }

  destroy() {
    forEach(this.links, (link) => {
      this.split(link);
    })
  }
}
